import { render, staticRenderFns } from "./ReferenceCard.vue?vue&type=template&id=59f051a1&scoped=true"
import script from "./ReferenceCard.vue?vue&type=script&lang=js"
export * from "./ReferenceCard.vue?vue&type=script&lang=js"
import style0 from "./ReferenceCard.vue?vue&type=style&index=0&id=59f051a1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f051a1",
  null
  
)

export default component.exports